import { render, staticRenderFns } from "./SbolChart.vue?vue&type=template&id=126b40c1&scoped=true&"
import script from "./SbolChart.vue?vue&type=script&lang=js&"
export * from "./SbolChart.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbolChart.vue?vue&type=style&index=0&id=126b40c1&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "126b40c1",
  null
  ,true
)

export default component.exports